import { SignupBackgroundLayout } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { ServiceCollectionLogo } from "@/components/signup/utils";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    CreateAWorkspaceHeading,
    CreateAWorkspaceText,
    Headings,
    SubHeading,
    WorkspacesAreWhereText
} from "../components";

export const NewUser = () => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );
    return (
        <SignupBackgroundLayout
            ProductLogo={<ServiceCollectionLogo />}
            theme="yellow"
        >
            {team26VisualUpdates ? (
                <Headings
                    main={<CreateAWorkspaceText />}
                    sub={<WorkspacesAreWhereText />}
                />
            ) : (
                <>
                    <CreateAWorkspaceHeading />
                    <SubHeading>
                        <WorkspacesAreWhereText />
                    </SubHeading>
                </>
            )}
            <SiteActivation />
        </SignupBackgroundLayout>
    );
};
